import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useFeedbackServicePostV1Feedback } from '../client/queries'

export const useCreateFeedback = () => {
  const { t } = useTranslation()

  return useFeedbackServicePostV1Feedback({
    onSuccess: () => toast.success(t('dialogs.feedback.toast.success')),
    onError: () => toast.error(t('dialogs.feedback.toast.error')),
  })
}
